import { Checkbox, DateTimePicker, DropDownList, TextBox } from "@repo/ui";

import { useMapSettings } from "../hooks";
import { useMapFilters } from "./filterContext";

export function EnrollmentFilter() {
	const { filters, filterChanged } = useMapFilters();
	const mapSettingsQuery = useMapSettings();

	return (
		<>
			<TextBox
				label="Enrollment ID"
				id="enrollmentId"
				value={filters.enrollmentId}
				changeHandler={filterChanged}
			/>
			<DateTimePicker
				id="startDateTime"
				label="Start Date"
				value={filters.startDateTime}
				changeHandler={filterChanged}
			/>
			<DateTimePicker
				id="endDateTime"
				label="End Date"
				value={filters.endDateTime}
				changeHandler={filterChanged}
			/>
			<Checkbox
				id="showSales"
				label={"Show Sales"}
				value={filters.showSales ?? false}
				changeHandler={filterChanged}
				inline
				hidden={!mapSettingsQuery.data?.canShowSales}
			/>
			<Checkbox
				id="goodSales"
				label={"Show Good Sales Only"}
				value={filters.goodSales ?? false}
				changeHandler={filterChanged}
				inline
				hidden={!filters.showSales}
			/>
			<DropDownList
				id="phoneCarrierType"
				label="Phone Carrier"
				fullLength
				value={filters.phoneCarrierType}
				changeHandler={filterChanged}
				values={[
					{ label: "All", value: "" },
					{ label: "Landline", value: "landline" },
					{ label: "Mobile", value: "mobile" },
					{ label: "VoIP", value: "voip" },
				]}
			/>
			<Checkbox
				id="showLines"
				label={"Show Route Paths"}
				value={filters.showLines}
				changeHandler={filterChanged}
				inline
			/>
		</>
	);
}
